/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandy_Full_Jay_ActInputs */

const en_sandy_full_jay_act = /** @type {(inputs: Sandy_Full_Jay_ActInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Append the feedback group name to the title, e.g. “[Team]”`)
};

const de_sandy_full_jay_act = /** @type {(inputs: Sandy_Full_Jay_ActInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name der Feedback-Gruppe an den Titel anhängen, z.B. „[Team]“`)
};

/**
* | output |
* | --- |
* | "Append the feedback group name to the title, e.g. “[Team]”" |
*
* @param {Sandy_Full_Jay_ActInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sandy_full_jay_act = /** @type {((inputs?: Sandy_Full_Jay_ActInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandy_Full_Jay_ActInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sandy_full_jay_act(inputs)
	return de_sandy_full_jay_act(inputs)
});